import { memo } from 'react';
import styled from 'styled-components';

const StyledImage = styled.img`
  width: 200px;
  height: ${({isAuth}) => isAuth ? 'auto' : '100%'};
  margin: 0px auto;
  padding: 0px;
`;

const Logo = memo((props) => (
  <StyledImage src={props.appLogo} alt={props.appName} {...props} />
));

export default Logo;
